var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.rootStyle)}}),(_vm.ready || _vm.$route.name === 'ErrorPage' || _vm.isStandAlone)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }